export default {
  PENDENTE: 'PENDENTE',
  AGENDADO: 'AGENDADO',
  NAO_ACESSADO: 'NAO_ACESSADO',
  PRAZO_EXPIRADO: 'PRAZO_EXPIRADO',
  AGENDADO_MANUALMENTE: 'AGENDADO_MANUALMENTE',
  AGUARDANDO_CONFIRMACAO_FUNCIONARIO: 'AGUARDANDO_CONFIRMACAO_FUNCIONARIO',
  RECUSADO_FUNCIONARIO: 'RECUSADO_FUNCIONARIO'
}